{
  "familyId": "REK-GEMENGD-TOETS",
  "questions": [
    {
      "id": "REK-GEMENGD-TOETS-001",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "multiple_choice",
      "question": "Reken uit: 5 + 3 × (12 − 4)",
      "options": ["29", "64", "32", "24"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meneer Van Dalen Wacht Op Antwoord",
            "content": "Volgorde: 1) Haakjes, 2) Machten, 3) Vermenigvuldigen/Delen, 4) Optellen/Aftrekken. Eerst haakjes: 12 − 4 = 8. Dan ×: 3 × 8 = 24. Dan +: 5 + 24 = 29.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_volgorde",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Volgorde bewerkingen: eerst haakjes (12 − 4 = 8), dan vermenigvuldigen (3 × 8 = 24), dan optellen (5 + 24 = 29). Onthoud: Meneer Van Dalen Wacht Op Antwoord (Machten, Vermenigvuldigen/Delen, Wortels, Optellen/Aftrekken).",
        "solutionSteps": [
          "Haakjes: 12 − 4 = 8",
          "Vermenigvuldigen: 3 × 8 = 24",
          "Optellen: 5 + 24 = 29"
        ],
        "distractorExplanations": {
          "0": "Goed! Haakjes eerst, dan ×, dan +. 5 + 3 × 8 = 5 + 24 = 29.",
          "1": "Je rekende van links naar rechts: (5 + 3) × (12 − 4) = 8 × 8 = 64. Maar 5 + 3 staat niet tussen haakjes! Alleen (12 − 4) is een haakje. Eerst: 3 × 8 = 24, dan 5 + 24 = 29.",
          "2": "Je dacht waarschijnlijk (5 + 3) × 4 = 32. Maar de volgorde is: haakjes (12−4=8), dan × (3×8=24), dan + (5+24=29).",
          "3": "Je berekende alleen 3 × (12 − 4) = 3 × 8 = 24, maar vergat de 5 erbij op te tellen. 5 + 24 = 29."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.left-to-right", "label": "Rekent van links naar rechts", "optionIndex": 1 },
          { "id": "rek.brackets-ignored", "label": "Verkeerde volgorde na haakjes", "optionIndex": 2 },
          { "id": "rek.partial-calculation", "label": "Vergeet eerste term op te tellen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-002",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "strategy_solver",
      "question": "Reken handig uit: 25 × 36. Kies eerst een handige manier en reken dan uit.",
      "options": [],
      "correctAnswer": "900",
      "data": {
        "strategySolver": {
          "expression": "25 × 36",
          "strategies": [
            { "id": "factoren", "label": "Splits in factoren", "icon": "split", "hint": "36 = 4 × 9, dan 25 × 4 = 100", "tier": "optimal" },
            { "id": "verdubbel_halveer", "label": "Verdubbel & halveer", "icon": "swap", "hint": "25 × 36 = 50 × 18 = 100 × 9", "tier": "optimal" },
            { "id": "splitsen", "label": "Splitsen", "icon": "puzzle", "hint": "25 × 36 = 25 × 30 + 25 × 6", "tier": "ok" },
            { "id": "cijferend", "label": "Cijferend rekenen", "icon": "list", "hint": "Schrijf onder elkaar — werkt, maar veel meer werk", "tier": "suboptimal" }
          ],
          "acceptedAnswers": ["900"]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Factoren herkennen",
            "content": "25 × 36: splits 36 in 4 × 9. Nu: 25 × 4 = 100, dan 100 × 9 = 900. Of: 25 × 36 = 25 × 4 × 9 = 100 × 9 = 900. Gebruik het standaardproduct 25 × 4 = 100!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_handig_keer",
      "variantIndex": 2,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "25 × 36 = 900. Handig: splits 36 in factoren: 36 = 4 × 9. Nu: 25 × 4 = 100 (standaardproduct!), dan 100 × 9 = 900. Dit is de kern van handig vermenigvuldigen: zoek naar combinaties die ronde getallen opleveren.",
        "solutionSteps": [
          "Herken: 36 = 4 × 9",
          "25 × 4 = 100 (standaardproduct)",
          "100 × 9 = 900"
        ]
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-003",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "multiple_choice",
      "question": "Jouw klas organiseert een sponsorloop. De eerste 3 dagen lopen 8 leerlingen elk 4 rondjes van €3 per rondje. De laatste 2 dagen lopen 6 leerlingen elk 5 rondjes van €2 per rondje. Hoeveel geld haalt de klas in totaal op?",
      "options": ["€408", "€288", "€384", "€468"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Splits in twee periodes",
            "content": "Periode 1: 3 dagen × 8 leerlingen × 4 rondjes × €3 = 96 rondjes × €3 = €288. Periode 2: 2 dagen × 6 leerlingen × 5 rondjes × €2 = 60 rondjes × €2 = €120. Totaal: €288 + €120 = €408. Tip: reken elke periode apart uit.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_context_meerstaps",
      "variantIndex": 3,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Periode 1: 3 × 8 × 4 = 96 rondjes × €3 = €288. Periode 2: 2 × 6 × 5 = 60 rondjes × €2 = €120. Totaal: €288 + €120 = €408. Bij meerstaps-opgaven: splits in periodes en reken elke periode apart uit.",
        "solutionSteps": [
          "Periode 1: 3 × 8 = 24 leerling-dagen, × 4 rondjes = 96 rondjes",
          "96 × €3 = €288",
          "Periode 2: 2 × 6 = 12 leerling-dagen, × 5 rondjes = 60 rondjes",
          "60 × €2 = €120",
          "Totaal: €288 + €120 = €408"
        ],
        "distractorExplanations": {
          "0": "Goed! €288 + €120 = €408 in totaal.",
          "1": "Je berekende alleen periode 1: 3 × 8 × 4 × 3 = 288. Maar er zijn ook nog 2 dagen met andere leerlingen! Tel periode 2 (€120) erbij op: 288 + 120 = 408.",
          "2": "Je gebruikte 4 rondjes voor beide periodes, maar de laatste 2 dagen lopen ze 5 rondjes. Periode 2: 2 × 6 × 5 × 2 = 120, niet 2 × 6 × 4 × 2 = 96. Totaal: 288 + 120 = 408.",
          "3": "Je gebruikte €3 per rondje voor beide periodes, maar de laatste 2 dagen is het €2 per rondje. Periode 2: 60 × €2 = €120, niet 60 × €3 = €180. Totaal: 288 + 120 = 408."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "rek.context-step-forgotten", "label": "Berekent alleen periode 1", "optionIndex": 1 },
          { "id": "rek.context-wrong-data", "label": "Gebruikt 4 rondjes i.p.v. 5 voor periode 2", "optionIndex": 2 },
          { "id": "rek.context-wrong-data", "label": "Gebruikt €3 i.p.v. €2 voor periode 2", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-004",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "strategy_solver",
      "question": "Reken handig uit: 1.600 ÷ 32. Kies eerst een handige manier en reken dan uit.",
      "options": [],
      "correctAnswer": "50",
      "data": {
        "strategySolver": {
          "expression": "1.600 ÷ 32",
          "strategies": [
            { "id": "herhaald_halveren", "label": "Herhaald halveren", "icon": "swap", "hint": "32 = 2⁵. Halveer 5 keer: 1.600 → 800 → 400 → 200 → 100 → 50", "tier": "optimal" },
            { "id": "factoren_4x8", "label": "Splits 32 = 4 × 8", "icon": "split", "hint": "1.600 ÷ 4 = 400, dan 400 ÷ 8 = 50", "tier": "optimal" },
            { "id": "halveer_beide", "label": "Halveer beide", "icon": "puzzle", "hint": "1.600 ÷ 2 = 800 en 32 ÷ 2 = 16. Dan 800 ÷ 16 = 50", "tier": "ok" },
            { "id": "cijferend", "label": "Cijferend (staartdeling)", "icon": "calculator", "hint": "Onder elkaar — werkt, maar veel werk voor deze som", "tier": "suboptimal" }
          ],
          "acceptedAnswers": ["50"]
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Herhaald halveren",
            "content": "32 = 2⁵, dus halveer 5 keer: 1.600 → 800 → 400 → 200 → 100 → 50. Of via factoren: 32 = 4 × 8. 1.600 ÷ 4 = 400, dan 400 ÷ 8 = 50.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_handig_deel",
      "variantIndex": 4,
      "citoDifficulty": 0.56,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "1.600 ÷ 32 = 50. Handig: 32 = 2⁵, dus halveer 5 keer: 1.600 → 800 → 400 → 200 → 100 → 50. Of via factoren: 1.600 ÷ 4 = 400, dan 400 ÷ 8 = 50.",
        "solutionSteps": [
          "Herken: 32 = 2 × 2 × 2 × 2 × 2",
          "1.600 ÷ 2 = 800 ÷ 2 = 400 ÷ 2 = 200 ÷ 2 = 100 ÷ 2 = 50",
          "Antwoord: 50"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 1.600 / 32 = 48. Maar 48 x 32 = 1.536, niet 1.600. Controleer: 50 x 32 = 1.600.",
          "1": "Goed! 1.600 / 32 = 50. Vijf keer halveren!",
          "2": "Je dacht waarschijnlijk 1.600 / 32 = 52. Maar 52 x 32 = 1.664, niet 1.600. Controleer: 50 x 32 = 1.600.",
          "3": "Je dacht waarschijnlijk 1.600 / 32 = 55. Maar 55 x 32 = 1.760, niet 1.600. Controleer: 50 x 32 = 1.600."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Deelfout: 1600÷32≈48", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Deelfout: 1600÷32≈52", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Deelfout: 1600÷32≈55", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-005",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "multiple_choice",
      "question": "Schat het antwoord: 489 × 21. Welke schatting komt het dichtst bij het exacte antwoord?",
      "options": ["Ongeveer 9.000", "Ongeveer 11.000", "Ongeveer 8.000", "Ongeveer 10.000"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Schatten: rond af naar handige getallen",
            "content": "489 ≈ 500, 21 ≈ 20. Schatting: 500 × 20 = 10.000. Exact: 489 × 21 = 10.269. De schatting van 10.000 zit er maar 269 naast! Tip: rond af naar getallen die makkelijk te vermenigvuldigen zijn.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_schatten",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "489 ≈ 500, 21 ≈ 20. Schatting: 500 × 20 = 10.000. Het exacte antwoord is 489 × 21 = 10.269 — de schatting zit er maar 2,6% naast. Bij schatten rond je af naar handige getallen die makkelijk te vermenigvuldigen zijn.",
        "solutionSteps": [
          "Afronden: 489 ≈ 500, 21 ≈ 20",
          "Schatting: 500 × 20 = 10.000",
          "Exact: 489 × 21 = 10.269 (dicht bij 10.000)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 450 x 20 = 9.000. Maar 489 is dichter bij 500 dan bij 450. 500 x 20 = 10.000 is nauwkeuriger.",
          "1": "Je dacht waarschijnlijk 500 x 22 = 11.000. Maar 21 is dichter bij 20 dan bij 22. 500 x 20 = 10.000 is nauwkeuriger.",
          "2": "Je dacht waarschijnlijk 400 x 20 = 8.000. Maar 489 is veel dichter bij 500 dan bij 400. 500 x 20 = 10.000 is nauwkeuriger.",
          "3": "Goed! 500 x 20 = 10.000 is de beste schatting. Exact: 10.269."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.rounding-wrong-direction", "label": "Rondt te ver naar beneden af", "optionIndex": 0 },
          { "id": "rek.rounding-wrong-direction", "label": "Rondt te ver naar boven af", "optionIndex": 1 },
          { "id": "rek.rounding-wrong-direction", "label": "Verkeerde afronding honderdtal", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "REK-GEMENGD-TOETS-006",
      "familyId": "REK-GEMENGD-TOETS",
      "module": "Basisrekenen",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "gemengd",
      "subSkill": "gemengd_toets",
      "questionType": "ordering",
      "question": "Zet de sommen in de juiste volgorde, van de kleinste uitkomst (boven) naar de grootste uitkomst (onder).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "100 - 50 ÷ 2",
          "(100 - 50) ÷ 2",
          "100 ÷ 2 - 50"
        ],
        "correctOrder": [2, 1, 0]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van bewerkingen",
            "content": "Reken eerst de haakjes uit, dan vermenigvuldigen/delen, en als laatste optellen/aftrekken.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gemengd_toets_volgorde_ordenen",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Laten we ze allemaal uitrekenen:\n1) 100 ÷ 2 - 50 = 50 - 50 = 0\n2) (100 - 50) ÷ 2 = 50 ÷ 2 = 25\n3) 100 - 50 ÷ 2 = 100 - 25 = 75\nDe juiste volgorde is dus: 0, 25, 75.",
        "solutionSteps": [
          "Reken 100 ÷ 2 - 50 uit: delen gaat voor, dus 50 - 50 = 0",
          "Reken (100 - 50) ÷ 2 uit: haakjes eerst, dus 50 ÷ 2 = 25",
          "Reken 100 - 50 ÷ 2 uit: delen gaat voor, dus 100 - 25 = 75",
          "Zet ze van klein naar groot: 0, 25, 75"
        ]
      }
    }
  ]
}